const globalStyling = {
    recyclopsFont: {
        fontFamily: 'Quicksand sans-serif',
        fontStyle: 'normal',
        fontSize: '2vw',
    },
};

export default globalStyling